import type { MenuCatalogSnapshot } from "@/domain/cart/cart-validity.types";

let latestMenuCatalogSnapshot: MenuCatalogSnapshot | null = null;

/** Returns the catalog snapshot from the most recent successful menu fetch. */
export function getLatestMenuCatalogSnapshot(): MenuCatalogSnapshot | null {
  return latestMenuCatalogSnapshot;
}

/** Updated by menu fetch pipeline after {@link buildMenuCatalogSnapshot}. */
export function setLatestMenuCatalogSnapshot(snapshot: MenuCatalogSnapshot | null): void {
  latestMenuCatalogSnapshot = snapshot;
}

/** Test-only reset. */
export function clearLatestMenuCatalogSnapshot(): void {
  latestMenuCatalogSnapshot = null;
}
